var _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "edit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-2",
    transform: "translate(2.986 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30843",
    "data-name": "Path 30843",
    d: "M5.261,16.876a2.045,2.045,0,0,1-1.4-.512,2,2,0,0,1-.6-1.733l.325-2.767a3.042,3.042,0,0,1,.764-1.588l7.211-7.42c1.8-1.853,3.68-1.9,5.586-.154s1.959,3.578.158,5.431L10.1,15.552a3.194,3.194,0,0,1-1.59.828l-2.828.47C5.534,16.859,5.4,16.876,5.261,16.876ZM14.387,2.693a2.7,2.7,0,0,0-1.862,1.025L5.314,11.146A1.948,1.948,0,0,0,4.9,12l-.325,2.767a.737.737,0,0,0,.193.657.808.808,0,0,0,.685.154l2.828-.47a1.98,1.98,0,0,0,.852-.444l7.211-7.42c1.089-1.127,1.484-2.169-.105-3.62A2.807,2.807,0,0,0,14.387,2.693Z",
    transform: "translate(-1.921 -1.426)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30844",
    "data-name": "Path 30844",
    d: "M16.452,10h-.06a5.875,5.875,0,0,1-5.233-4.951.646.646,0,0,1,1.276-.2A4.6,4.6,0,0,0,16.529,8.72a.643.643,0,0,1,.574.7A.663.663,0,0,1,16.452,10Z",
    transform: "translate(-2.383 -2.271)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30845",
    "data-name": "Path 30845",
    d: "M19.584,22.6H2.943a.676.676,0,1,1,0-1.352H19.584a.676.676,0,1,1,0,1.352Z",
    transform: "translate(-2.25 -1.998)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8467",
    "data-name": "Rectangle 8467",
    width: 24,
    height: 24,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a153e0057ec254c2c83cedd5dd5a8fea.svg";
export { ForwardRef as ReactComponent };